<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-live-auctions></app-breadcrumb-live-auctions>
    <app-auctions-two-section></app-auctions-two-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
